export default __webpack_public_path__ + "static/media/react-native.8c67f62f.jpg";